/**
 * Returns a function that calls the given function in the given `enterprise-framework` store.
 *
 * throws an error if the given enterprise-framework store can't be found at call time
 *
 * @param {string} efName - the name of the store as it is on `window.ef`
 * @param {string} fnName - the name of the store function (e.g. `window.ef[efName][fnName]`)
 * @param {string} defaultResponse - a default response to return in case the store function is not found
 * @returns {function} the result of calling the `ef` store function, or the default response, or throws an exception
 */
function proxyToEfStore(efName, fnName, defaultResponse) {
	return function (...args) {
		if(
			window.ef &&
			window.ef[efName] &&
			window.ef[efName][fnName] &&
			typeof window.ef[efName][fnName] === 'function'
		) {
			return window.ef[efName][fnName](...args); // pass all arguments received to the destination function
		} else if(defaultResponse) {
			return defaultResponse;
		} else{
			throw new Error(`Error: ef.${efName}.${fnName}() not available.`);
		}
	};
}

export function proxyToClubsStore(fnName) {
	return proxyToEfStore('clubsStore', fnName);
}

export function proxyToClubStore(fnName) {
	return proxyToEfStore('clubStore', fnName);
}

export function proxyToProfileStore(fnName) {
	return proxyToEfStore('profileStore', fnName);
}

export function proxyToUrlStore(fnName) {
	return proxyToEfStore('urlStore', fnName);
}

export function proxyToProspectProfileStore(fnName) {
	return proxyToEfStore('prospectProfileStore', fnName);
}

export function proxyToNearestClubStore(fnName) {
	return proxyToEfStore('nearestClubStore', fnName);
}

export function proxyToAlertNotificationStore(fnName) {
	return proxyToEfStore('alertNotificationStore', fnName);
}
